import React, { useContext, useRef } from 'react'
import styles from './WorkingStatus.module.css'
import local from './WorkingStatusVertical.module.css'
import { StepContext } from '@/components/Context/StepContext'
import { SelectPillButton } from '@/components/Common/SelectPillButton'
import { StepBadge } from '@/components/Common/StepBadge'
import { WorkingStatusProps } from './types'
import { useAbTestGtm } from '@/components/utils/abTest'
import { FollowIcon } from '../../../FormGuidance/FollowIcon'
import { useFollowIcon } from '../../../FormGuidance/FollowIcon/useFollowIcon'

// 縦型EF step1(現在の状況)
export const WorkingStatusVertical = ({ gtmTags, stepNumber }: WorkingStatusProps) => {
    const { handleNext, updateFormData, formData, isCurrentStepValid, isAnimating, currentStep } = useContext(StepContext)

    const parentRef = useRef<HTMLDivElement>(null)
    const questionRef = useRef<HTMLDivElement>(null)
    const tileAreaRef = useRef<HTMLDivElement>(null)
    const targets = [
        { ref: questionRef, isComplete: false },
        { ref: tileAreaRef, isComplete: isCurrentStepValid },
    ]
    const { iconStyle } = useFollowIcon({
        parentRef,
        targets,
        isAnimating,
        layoutKey: currentStep,
    })

    const handleSelect = (status: string) => {
        updateFormData('workingStatus', status)
        // DEV-3061: フロンティアstepのみ遷移
        if (currentStep === stepNumber - 1) {
            handleNext()
        }
    }

    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div
            className={styles.wrapper}
            ref={parentRef}
            data-view-label={dataViewLabel(gtmTags.dataViewLabel)}
        >
            <FollowIcon iconStyle={iconStyle} />

            <div className={styles.title} ref={questionRef}>
                <h2 className={styles.titleText}>
                    <StepBadge number={stepNumber} />現在の状況はいかがですか？
                </h2>
            </div>
            <div className={local.selectionWrapper} ref={tileAreaRef}>
                <SelectPillButton
                    label='在職中の方'
                    selected={formData.workingStatus === '就業中'}
                    onClick={() => handleSelect('就業中')}
                    dataClickLabel={dataClickLabel(gtmTags.dataClickLabels.working)}
                />
                <SelectPillButton
                    label='離職中の方'
                    selected={formData.workingStatus === '離職中'}
                    onClick={() => handleSelect('離職中')}
                    dataClickLabel={dataClickLabel(gtmTags.dataClickLabels.unemployed)}
                />
            </div>
        </div>
    )
}

export default WorkingStatusVertical
